module.exports = __webpack_public_path__ + "static/media/phone.b522cc6c.svg";